import React from 'react';
import PropTypes from 'prop-types';

export const DownloadIcon = ({ color = '#8D90A5', ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 4.91667V12.3106M10 12.3106L7.25 9.53788M10 12.3106L12.75 9.53788M16.875 12.3106V13.2349C16.875 13.7251 16.6818 14.1953 16.338 14.5419C15.9942 14.8886 15.5279 15.0833 15.0417 15.0833H4.95833C4.4721 15.0833 4.00579 14.8886 3.66197 14.5419C3.31815 14.1953 3.125 13.7251 3.125 13.2349V12.3106"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

DownloadIcon.propTypes = {
  color: PropTypes.string,
};
